<app-base-servico
  [servico]="servico"
  [activeIndex]="ACTIVE_INDEX"
  [solicitanteTemplate]="solicitanteTemplate"
  [servicoTemplate]="servicoTemplate"
  [confirmacaoTemplate]="confirmacaoTemplate"
>
</app-base-servico>

<ng-template #solicitanteTemplate>
  <form
    [formGroup]="formSolicitante"
    (ngSubmit)="putDadosSolicitante()"
    class="flex gap-2 flex-column"
  >
    <label>Nome do solicitante:</label>
    <input
      pInputText
      id="nomeSolicitante"
      formControlName="nomeSolicitante"
      autocomplete="off"
      aria-label="Nome do solicitante"
    />

    <label>CPF do solicitante:</label>
    <p-inputMask
      id="cpfSolicitante"
      mask="999.999.999-99"
      formControlName="cpfSolicitante"
      autocomplete="off"
      ariaLabel="CPF do solicitante"
    />

    <label>E-mail do solicitante:</label>
    <input
      pInputText
      id="emailSolicitante"
      style="max-width: 400px"
      formControlName="emailSolicitante"
      autocomplete="off"
      aria-label="E-mail do solicitante"
    />

    <h4 class="subtitulo">Declaração de Veracidade</h4>
    <p style="font-size: 12px; margin-top: 10px">
      Declaro que as informações prestadas e documentos apresentados são
      verdadeiros e estou ciente de que, em caso de vistoria "in loco", havendo
      divergência nas informações declaradas, estarei sujeito as sansões e
      penalidades e ao pagamento da indenização da diferença dos valores entre
      as tarifas aplicadas, ao preço vigente na ocasião da vistoria.
    </p>

    <p-checkbox
      formControlName="declaracaoVeracidade"
      value="aceite"
      inputId="declaracaoVeracidade"
      label="Li e concordo"
    ></p-checkbox>
    <h4 class="subtitulo">Declaração de Aceite</h4>
    <p style="font-size: 12px; margin-top: 10px">
      Estou ciente de que em caso de não envio da documentação compromissada,
      após a análise da CASAN, será gerada a REJEIÇÃO IMEDIATA do atendimento e
      será necessária a abertura de uma nova solicitação, com a documentação
      completa. Declaro, ainda, estar ciente de que na hipótese acima citada, o
      corte e/ou supressão de ligação ou cancelamento dos serviços não decorre
      do eventual inadimplemento financeiro das obrigações contratuais, mas sim
      da violação do princípio da confiança e da boa-fé objetiva, em razão do
      descumprimento do compromisso assumido de entrega de documentos, visando,
      assim, proporcionar segurança jurídica mínima às relações comerciais da
      Companhia. Lembramos que sempre que necessário, a CASAN se reserva o
      direito de solicitar outros documentos além dos já requeridos, de acordo
      com a peculiaridade de cada caso.
    </p>

    <p-checkbox
      formControlName="declaracaoAceite"
      value="aceite"
      inputId="declaracaoAceite"
      label="Li e concordo"
    ></p-checkbox>

    <button
      pButton
      type="submit"
      [disabled]="formSolicitante.invalid || formSolicitante.disabled"
      label="Próximo"
      [loading]="loading"
      class="botao-proximo"
    ></button>
  </form>
</ng-template>

<ng-template #servicoTemplate>
  <form
    (ngSubmit)="handleFormServico()"
    [formGroup]="formServico"
    *ngIf="servico && !SHOW_FILES_FORM"
    style="display: flex; flex-direction: column; gap: 4px"
  >
    <label>Número do Processo:</label>
    <input
      pInputText
      id="buscaJudicialProcesso"
      formControlName="buscaJudicialProcesso"
      autocomplete="off"
      aria-label="Número do Processo"
      style="max-width: 350px"
      maxlength="50"
    />

    <label>Número do Ofício:</label>
    <input
      pInputText
      id="buscaJudicialOficio"
      formControlName="buscaJudicialOficio"
      autocomplete="off"
      aria-label="Número do Ofício"
      style="max-width: 350px"
      maxlength="50"
    />

    <span style="font-size: 10px; color: crimson">
      * É necessário preencher ao menos um dos campos acima
    </span>

    <label>Pesquisa por:</label>
    <p-dropdown
      #pesquisaPor
      formControlName="pesquisaPor"
      [options]="pesquisaPorOptions"
      optionLabel="label"
      (onChange)="changePesquisaPorHandle($event)"
    ></p-dropdown>

    <ng-container *ngIf="pesquisaPor.value.value == 0">
      <label>CPF *:</label>
      <p-inputMask
        id="cpf"
        mask="999.999.999-99"
        placeholder="000.000.000-00"
        formControlName="cpfCnpj"
        autocomplete="off"
        ariaLabel="CPF"
      />
    </ng-container>

    <ng-container *ngIf="pesquisaPor.value.value == 1">
      <label>CNPJ *:</label>
      <p-inputMask
        id="cnpj"
        mask="99.999.999/9999-99"
        placeholder="00.000.000/0000-00"
        formControlName="cpfCnpj"
        autocomplete="off"
        ariaLabel="cnpj"
      />
    </ng-container>

    <label
      >Nome completo:
      <span *ngIf="pesquisaPor.value.value == 2"> *</span></label
    >
    <input
      pInputText
      id="nome"
      formControlName="nome"
      autocomplete="off"
      aria-label="Nome Completo"
    />

    <button
      pButton
      type="submit"
      [disabled]="formServico.invalid || formServico.disabled"
      label="Próximo"
      class="botao-proximo"
    ></button>
  </form>

  <form
    [formGroup]="formArquivos"
    (ngSubmit)="concluirCadastro()"
    *ngIf="servico && SHOW_FILES_FORM"
  >
    <div class="form_wrapper">
      <label
        >Preencha no quadro abaixo as informações da sua solicitação
        <i>(OBRIGATÓRIO)</i>:</label
      >
      <textarea
        pInputTextarea
        rows="5"
        formControlName="informacoes"
        [placeholder]="servico.informacoes"
        class="w-full lg:w-9"
        style="resize: none"
        maxlength="4000"
      ></textarea>
    </div>

    <div class="form_arquivos">
      <h4 class="subtitulo">
        DOCUMENTOS IDENTIFICAÇÃO DIGITALIZADOS <i>(OBRIGATÓRIO)</i>
      </h4>
      <p-fileUpload
        #idFile
        [disabled]="loading"
        [showUploadButton]="false"
        [fileLimit]="arquivosManager.NUMERO_MAXIMO_ARQUIVOS_IDENTIFICACAO"
        [multiple]="true"
        [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS"
        chooseLabel="Selecionar arquivos"
        cancelLabel="Limpar arquivos"
        class="file"
        accept="image/*,application/pdf"
        invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
        invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
        invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
        invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}"
        (onSelect)="
          arquivosManager.onFileSelect(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_IDENFITICACAO
          )
        "
        (onRemove)="
          arquivosManager.onFileRemove(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_IDENFITICACAO
          )
        "
        (onClear)="
          arquivosManager.onClearFiles(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_IDENFITICACAO
          )
        "
      >
        <ng-template pTemplate="toolbar">
          <ul class="py-3">
            <li>Para pessoa física: CPF e RG ou CNH</li>
          </ul>
          <sub>É PERMITIDO SELECIONAR ATÉ 4 ARQUIVOS</sub>
        </ng-template>
      </p-fileUpload>

      <h4 class="subtitulo">
        DOCUMENTOS ESPECÍFICOS DIGITALIZADOS <i>(OBRIGATÓRIO)</i>
      </h4>
      <p-fileUpload
        #juizFile
        [disabled]="loading"
        [showUploadButton]="false"
        [fileLimit]="1"
        [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS"
        chooseLabel="Selecionar arquivo"
        cancelLabel="Limpar arquivos"
        class="file"
        accept="image/*,application/pdf"
        invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
        invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
        invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
        invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}"
        (onSelect)="
          arquivosManager.onFileSelect(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_JUIZ
          )
        "
        (onRemove)="
          arquivosManager.onFileRemove(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_JUIZ
          )
        "
        (onClear)="
          arquivosManager.onClearFiles(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_JUIZ
          )
        "
      >
        <ng-template pTemplate="toolbar">
          <div class="py-3">
            Documento expedido por Juiz de Direito autorizando a consulta no
            banco de dados da CASAN, tais como Alvará Judicial ou
            Despacho/Decisão Judicial.
          </div>
        </ng-template>
      </p-fileUpload>

      <h4 class="subtitulo">DOCUMENTOS COMPLEMENTARES DIGITALIZADOS</h4>

      <p-fileUpload
        [disabled]="loading"
        [showUploadButton]="false"
        [fileLimit]="3"
        [multiple]="true"
        [customUpload]="true"
        [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS"
        chooseLabel="Selecionar arquivos"
        cancelLabel="Limpar arquivos"
        class="file"
        accept="image/*,application/pdf"
        invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
        invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
        invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
        invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}"
        (onSelect)="
          arquivosManager.onFileSelect(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_OUTROS
          )
        "
        (onRemove)="
          arquivosManager.onFileRemove(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_OUTROS
          )
        "
        (onClear)="
          arquivosManager.onClearFiles(
            $event,
            arquivosManager.ANEXO_DOCUMENTO_OUTROS
          )
        "
      >
        <ng-template pTemplate="toolbar">
          <ul class="py-3">
            <li>
              Procuração nomeando o solicitante como representante do
              beneficiário/autor do processo, com a possibilidade de
              apresentação de outras procurações ou substabelecimentos
              comprovando a cadeia sucessória entre as partes envolvidas
            </li>
            <li>Documento de identificação do procurador.</li>
          </ul>
          <sub>É PERMITIDO SELECIONAR ATÉ 3 ARQUIVOS</sub>
        </ng-template>
      </p-fileUpload>
    </div>
    <button
      pButton
      type="submit"
      [disabled]="
        formArquivos.invalid ||
        formArquivos.disabled ||
        idFile.files.length <
          arquivosManager.NUMERO_MINIMO_ARQUIVOS_IDENTIFICACAO ||
        idFile.files.length >
          arquivosManager.NUMERO_MAXIMO_ARQUIVOS_IDENTIFICACAO ||
        juizFile.files.length < 1
      "
      [loading]="loading"
      label="Próximo"
      class="botao-proximo"
    ></button>
  </form>
</ng-template>

<ng-template #confirmacaoTemplate>
  <app-confirmacao-solicitacao
    class="fadein animation-duration-500"
    [dadosConfirmacao]="dadosSolicitacao"
  ></app-confirmacao-solicitacao>
</ng-template>
